import { GDFDiversionRecord } from '../../../gdf/type';

export default function DiversionTooltip({ record }: { record: GDFDiversionRecord }) {
    return (
        <div>
            <div>{record.airportId}</div>
            <div className="d-flex gap-2">
                <div>
                    <span>From: {record.fromCount}</span>
                    {record.fromTrend === 'D' && <span> dec</span>}
                    {record.fromTrend === 'I' && <span> inc</span>}
                </div>
                <div>
                    <span>To: {record.toCount}</span>
                    {record.toTrend === 'D' && <span> dec</span>}
                    {record.toTrend === 'I' && <span> inc</span>}
                </div>
            </div>
        </div>
    );
}
